import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=78425ca9&"
import script from "./AccountType.vue?vue&type=script&lang=js&"
export * from "./AccountType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports